import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    inject,
} from '@angular/core';
import { EmojiData, EmojiEvent } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import {
    EmojiUrlFn,
    IEmojiConfig,
    TEmojiMartLocale,
    defaultConfig,
    toEmojiMartLocale,
} from './emoji-picker.interface';
import { EmojiPickerService } from './emoji-picker.service';
import { AppService } from '@app/app.service';
import { PickerModule } from '@ctrl/ngx-emoji-mart';

/**
 * Компонент отображения диалога выбора емотикона.
 */
@Component({
    selector: 'app-emoji-picker',
    templateUrl: './emoji-picker.component.html',
    standalone: true,
    imports: [PickerModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmojiPickerComponent implements OnChanges {
    private readonly appService = inject(AppService);
    private readonly emojiService = inject(EmojiPickerService);

    /**
     * Текущий набор текстов для локализации емозди пикера.
     */
    locale: TEmojiMartLocale = toEmojiMartLocale(this.appService.language_dictionary);

    /**
     * Функция определения URL'а к картинке с эмотиконом.
     */
    emojiUrlFn: EmojiUrlFn = this.emojiService.getEmojiUrlFn(defaultConfig);

    /**
     * Настройки этого компонента.
     */
    @Input() config: IEmojiConfig = defaultConfig;

    /**
     * Событие выбора нового эмотикона.
     */
    @Output() emojiPicked = new EventEmitter<EmojiData>();

    /**
     * Изменение конфигурации компонента.
     */
    ngOnChanges(): void {
        this.emojiUrlFn = this.emojiService.getEmojiUrlFn(this.config);
    }

    /**
     * Обработка события выбора емотикона из компонента ngx-emoji-mart.
     */
    pickEmoji(e: EmojiEvent): void {
        this.emojiPicked.emit(e.emoji);
    }
}
